'use client';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useMemo, useSyncExternalStore } from 'react';
const EMPTY_HASH = '';
const getHash = () => {
    if (typeof window === 'undefined')
        return EMPTY_HASH;
    return window.location.hash;
};
// Wouter (v3) monkey-patches `history.pushState` / `history.replaceState` to
// dispatch matching custom events. Subscribe to those too so a SPA
// navigation that only mutates the URL fragment — e.g. clicking a `<Link>`
// whose href shares the current pathname — still re-reads
// `window.location.hash`. Without these, our snapshot goes stale because
// neither `hashchange` nor `popstate` fires for `pushState`.
const subscribe = (onChange) => {
    window.addEventListener('hashchange', onChange);
    window.addEventListener('popstate', onChange);
    window.addEventListener('pushState', onChange);
    window.addEventListener('replaceState', onChange);
    return () => {
        window.removeEventListener('hashchange', onChange);
        window.removeEventListener('popstate', onChange);
        window.removeEventListener('pushState', onChange);
        window.removeEventListener('replaceState', onChange);
    };
};
const getServerHash = () => EMPTY_HASH;
/**
 * Reactive subscription to `window.location.hash`. Updates when the hash
 * changes via `hashchange` / `popstate`, and re-reads on pathname changes
 * so programmatic `history.pushState` navigations (which don't emit
 * hashchange) are also picked up.
 */
export const useHash = () => {
    const externalHash = useSyncExternalStore(subscribe, getHash, getServerHash);
    const pathname = usePathname();
    return useMemo(() => (typeof window === 'undefined' ? EMPTY_HASH : window.location.hash), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [externalHash, pathname]);
};
//# sourceMappingURL=useSettingsHash.js.map